<template>
  <page>
    <ml-studio-upsell-introduction @request-demo="requestDemo()" />
    <div class="sticky">
      <ml-studio-book-a-demo-banner @request-demo="requestDemo()" />
    </div>
    <template v-for="section in sections">
      <ml-studio-two-col-section
        :key="section.title"
        :header="section.header"
        :title="section.title"
        :description="section.description"
        :image-name="section.imageName"
        :left-orientation="section.leftOrientation"
      />
    </template>
    <ml-studio-discover-models />
    <ml-studio-one-solution />
    <ml-studio-statement />
    <ml-studio-frequently-asked-questions />
  </page>
</template>

<script>
import MlStudioFrequentlyAskedQuestions from '@/modules/ml-studio/components/MlStudioFrequentlyAskedQuestions.vue'
import Page from '@/common/components/page/Page.vue'
import MlStudioUpsellIntroduction from '@/modules/ml-studio/components/MlStudioUpsellIntroduction.vue'
import MlStudioBookADemoBanner from '@/modules/ml-studio/components/MlStudioBookADemoBanner.vue'
import MlStudioOneSolution from '@/modules/ml-studio/components/MlStudioOneSolution.vue'
import MlStudioStatement from '@/modules/ml-studio/components/MlStudioStatement.vue'
import MlStudioDiscoverModels from '@/modules/ml-studio/components/MlStudioDiscoverModels.vue'
import { customConfirm } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import { ProductRequestTypesEnum } from '@/common/enum/ProductRequestTypesEnum'
import MlStudioTwoColSection from '@/modules/ml-studio/components/MlStudioTwoColSection.vue'

export default {
  name: 'MLStudioPromotionPage',

  components: {
    MlStudioTwoColSection,
    MlStudioDiscoverModels,
    MlStudioStatement,
    MlStudioOneSolution,
    MlStudioBookADemoBanner,
    MlStudioUpsellIntroduction,
    Page,
    MlStudioFrequentlyAskedQuestions
  },

  data() {
    return {
      sections: [
        {
          header: 'InfinityAI_AdaptiveAI_Header',
          title: 'InfinityAI_AdaptiveAI_Title',
          description: 'InfinityAI_AdaptiveAI_Description',
          imageName: 'adaptiveai',
          leftOrientation: true
        },
        {
          header: 'InfinityAI_ExplainableAI_Header',
          title: 'InfinityAI_ExplainableAI_Title',
          description: 'InfinityAI_ExplainableAI_Description',
          imageName: 'explainableai',
          leftOrientation: false
        },
        {
          header: 'InfinityAI_SelfOptimisation_Header',
          title: 'InfinityAI_SelfOptimisation_Title',
          description: 'InfinityAI_SelfOptimisation_Description',
          imageName: 'selfoptimisation',
          leftOrientation: true
        },
        {
          header: 'InfinityAI_PnP_Header',
          title: 'InfinityAI_PnP_Title',
          description: 'InfinityAI_PnP_Description',
          imageName: 'pnp',
          leftOrientation: false
        }
      ]
    }
  },

  methods: {
    requestDemo() {
      customConfirm(
        this.$t('InfinityAI_Popup_Title'),
        this.$t('InfinityAI_Popup_Description'),
        this.$t('InfinityAI_Popup_SendRequest'),
        this.$t('InfinityAI_Popup_Cancel')
      )
        .then(() => {
          RestApi({
            method: 'post',
            url: `projects/${this.$route.query.project_id}/notification`,
            data: {
              productName: ProductRequestTypesEnum.INFINITY_AI
            }
          })
            .then(() => {
              this.$message({
                message: this.$t('InfinityAI_Popup_RequestSent'),
                type: 'success'
              })
            })
            .catch(() => {
              this.$message({
                message: this.$t('InfinityAI_Popup_RequestFailed'),
                type: 'error'
              })
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
div.sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}

>>> .page {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/pages/MlStudioPromotionPage.vue